import ColorItem from "./ColorItem"

export default ColorItem
